<template>
  <div class="pb-20">
    <h1
      class="flex justify-center w-auto font-serif text-3xl mt-10 pl-4 pb-6" :class="textGray400()"
    >{{ category.name }}
    </h1>
    <carousel-fixed v-if="this.$route.params.slug === 'str'" class="pb-5" />

    <ais-instant-search :search-client="searchClient" index-name="products">
      <ais-configure
        :disjunctive-facets-refinements.camel="{ category_slug: [$route.params.slug] }"
      />
      <ais-search-box class="mt-4 mb-8 w-5/6 mx-auto md:w-full"
        :placeholder="$t('menu.search')" />
      <div class="flex flex-col md:flex-row justify-between w-5/6 mx-auto md:w-full">
        <div class="flex flex-col md:w-1/3.5 w-full md:mt-10">
          <ais-clear-refinements>
            <div slot-scope="{ canRefine, refine, createURL }">
              <a
                class="bg-b2c-red-300 text-white px-2 py-1 rounded hover:bg-white
                border border-b2c-red-300 hover:text-b2c-red-300 text-sm"
                :href="createURL()"
                @click.prevent="refine"
                v-if="canRefine"
              >
                {{ $t('filters.clear') }}
              </a>
            </div>
          </ais-clear-refinements>
          <div class="mt-6 w-full">
            <h2 class="uppercase font-bold mb-1">{{ $t('catalog.brand') }}</h2>
            <ais-refinement-list :attribute="brandAttribute" v-if="brandAttribute" show-more />
          </div>
          <div class="mt-6 w-full">
            <h2 class="uppercase font-bold mb-1">{{ $t('catalog.subcategory') }}</h2>
            <ais-refinement-list :attribute="subcategoryAttribute" v-if="subcategoryAttribute" show-more />
          </div>
          <div class="mt-6 w-full" v-for="tag in category.attribute_tags" :key="tag.id">
            <h2 class="uppercase font-bold mb-1">{{tag.tag}}</h2>
            <ais-refinement-list :attribute="tag.slug+'_'+$i18n.locale" v-if="tag.slug!== 'composer'"
              show-more />
            <ais-refinement-list :attribute="tag.slug+'_'+$i18n.locale" v-else
              show-more
              :show-more-limit="1000"
              searchable
              :searchable-placeholder="$t('filters.searchComposer')"
              :sort-by="['isRefined', 'name:asc']"
            />
          </div>
        </div>
        <div class="flex flex-col w-full md:ml-6">
          <ais-hits>
            <div slot="item" slot-scope="{ item }">
              <product-widget :product="item" class="w-full"/>
            </div>
          </ais-hits>
          <ais-pagination class="mt-10 mb-16 w-5/6 mx-auto md:w-full" />
        </div>
      </div>

    </ais-instant-search>
  </div>
</template>

<script>
import ProductWidget from '@/components/ProductWidget.vue';
import { mapGetters } from 'vuex';
import AlgoliaMixin from '@/mixins/AlgoliaMixin';
import axios from 'axios';
import CarouselFixed from '../components/graphics/CarouselFixed.vue';

export default {
  metaInfo() {
    const description = this.$t('metaDescriptions.categoryCatalogs');
    return {
      meta: [
        {
          name: 'description',
          content: description,
        },
      ],
    };
  },

  components: {
    ProductWidget,
    CarouselFixed,
  },

  data() {
    return {
      /* products: [],
      pagination: {},
      currentPage: this.$route.query.page ? this.$route.query.page : 1,

      productsPerPage: 18, */

      category: {},
      brandAttribute: '',
      subcategoryAttribute: '',
      subcategories: [],
      products: [],

      /* type: 'ProductCategory',
      currentSlug: this.$route.params.slug,

      isLoading: true, */
    };
  },

  computed: {
    ...mapGetters({
      changedLocale: 'auth/changedLocale',
    }),

    number() {
      return this.products.length > 0 ? this.products.length : this.productsPerPage;
    },

    selectedComposers() {
      if (this.attributes.composer) {
        return this.attributes.composer.filter((composer) => {
          if (this.activeFilters.attributes.composer) {
            return this.activeFilters.attributes.composer.find((slug) => slug === composer.value_slug);
          }
          return null;
        });
      }
      return null;
    },

    filteredComposersByLetter() {
      if (this.attributes.composer) {
        return this.attributes.composer.filter((composer) => composer.attribute_value[0].toUpperCase() === this.selectedLetter
          && !this.selectedComposers.find((selectedComposer) => selectedComposer.value_slug === composer.value_slug));
      }
      return null;
    },
  },

  mixins: [AlgoliaMixin],

  watch: {
    changedLocale() {
      this.getCategory();
    },

    $route() {
      this.getCategory();
    },
  },

  created() {
    this.getCategory();
  },

  methods: {
    getCategory() {
      this.brandAttribute = '';
      this.subcategoryAttribute = '';
      axios.get(`/api/product-categories/${this.$route.params.slug}`).then(({ data }) => {
        this.category = data;
        this.brandAttribute = 'brand';
        this.subcategoryAttribute = `subcategory_${this.$i18n.locale}`;
        // this.getSubcategories();
      });
    },

    getSubcategories() {
      axios.get(`/api/product-categories/${this.$route.params.slug}/subcategories?brand=${this.activeFilters.brand}&filter_attributes={${this.getQueryAttributes('')}}`).then(({ data }) => {
        this.subcategories = data;
      });
    },

    /* setCategory() {
      this.getCategory();
      this.type = 'ProductCategory';
      this.currentSlug = this.$route.params.slug;
      if (this.$route.query.sub) {
        this.type = 'ProductSubcategory';
        this.currentSlug = this.$route.query.sub;
      }
      // this.getPaginatedProducts();
      this.getProducts();
      this.getSubcategories();
      this.getBrands();
    },

    getBrands() {
      let query = `/api/product-categories/${this.$route.params.slug}/brands?`;
      query = this.getQuerySubcategories(query);
      query += `filter_attributes={${this.getQueryAttributes('')}}`;
      axios.get(query).then(({ data }) => {
        this.brands = data;
        if (this.brands.length === 1) {
          this.activeFilters.brand = this.brands[0].slug;
          this.getSubcategories();
          this.getAttributeFilters();
        }
      });
    },

    getAttributeFilters() {
      let query = `/api/product-categories/${this.$route.params.slug}/attributes?`;
      query = this.getQuerySubcategories(query);
      query += `brand=${this.activeFilters.brand}`;
      axios.get(query).then(({ data }) => {
        this.attributes = data;
      });
    },

    /* setSubcategory(subcategory) {
      this.currentPage = 1;
      this.$router.push(`/product-categories/${this.$route.params.slug}?sub=${subcategory.slug}&page=1`);
    },

    changePage() {
      this.currentPage = this.pagination.current_page ? this.pagination.current_page : this.currentPage;
      this.getProducts();
      /* if (!this.$route.query.sub) {
        this.$router.push(`/product-categories/${this.$route.params.slug}?page=${this.currentPage}`);
        return;
      }
      this.$router.push(`/product-categories/${this.$route.params.slug}?sub=${this.$route.query.sub}&page=${this.currentPage}`);
    }, */

    getProducts() {
      this.isLoading = true;
      this.products = [];
      window.scroll(0, 0 - 50);
      axios.get(`/api/products?category=${this.category.slug}`)
        .then(({ data }) => {
          this.products = data;
          console.log(this.products);
          this.isLoading = false;
        });
    },

    transformItems(items) {
      this.isLoading = true;
      const skues = [];
      items.forEach((item) => {
        skues.push(item.sku);
      });
      axios.get('/api/products/skues', skues)
        .then(({ data }) => {
          this.isLoading = false;
          return data;
        });
    },

    printProducts(items) {
      console.log(items);
    },

    /* subcategoryClass(subcategory) {
      if (subcategory.slug === this.currentSlug) {
        return 'text-b2c-grey-400 underline font-semibold';
      }
      return 'hover:font-semibold hover:underline';
    }, */
  },
};
</script>

<style lang="scss">
  .ais-Pagination-item--selected > a {
    background-color: rgba(198, 42, 40, 1) !important;
    color: white !important;
  }

  .ais-Pagination-item--selected > a:hover {
    background-color: rgba(198, 42, 40, 1) !important;
    color: white !important;
  }

  .ais-Pagination-item > a {
    color: rgba(156, 163, 175, 1);
    border-color: rgba(156, 163, 175, 1) !important;
    background-color: white;
  }

  .ais-Pagination-item > a:hover {
    color: white !important;
    background-color: rgba(156, 163, 175, 1) !important;
  }

  .ais-RefinementList-label {
    display: flex;
    justify-content: space-between;
    place-items: center;
    text-align: left;
    margin-bottom: 0.2rem;
  }

  .ais-RefinementList-labelText {
    font-size: small;
    text-transform: lowercase;
    width: 100%;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    word-break: break-all;
  }

  .ais-Highlight {
    font-size: small;
    text-transform: lowercase;
    width: 100%;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    word-break: break-all;
  }

  .ais-RefinementList-count {
    place-items: center;
    font-family: sans-serif;
    font-size: x-small;
    text-decoration: none;
    width: 2.3rem;
    display: flex;
    justify-content: center;
    justify-items: center;
  }

 button.ais-RefinementList-showMore {
    background-color: rgba(198, 42, 40, 1) !important;
    color: white;
    border-width: 1px !important;
    border-color: rgba(198, 42, 40, 1) !important;
    border-style: solid !important;
  }

  button.ais-RefinementList-showMore:hover {
    color: rgba(198, 42, 40, 1);
    background-color: white !important;
    border-width: 1px !important;
    border-color: rgba(198, 42, 40, 1) !important;
    border-style: solid !important;
  }

  button.ais-RefinementList-showMore--disabled:hover {
    background-color: rgba(198, 42, 40, 1) !important;
    color: white;
    border-width: 1px !important;
    border-color: rgba(198, 42, 40, 1) !important;
    border-style: solid !important;
  }

  .ais-SearchBox-input {
    font-size: small;
  }

</style>
